export const URL_PATH = '/category/one';
